import { BusinessType } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useBusinessTypes() {
  const [fetching, setFetching] = useState(false);
  const [businessTypes, setBusinessTypes] = useState<{ [businessTypeKey: string]: BusinessType }>({});

  async function fetchBusinessTypes() {
    try {
      setFetching(true);
      const res = await api.fetchBusinessTypes();
      if (!res.Success) throw new Error(res.ErrorMessage);
      setBusinessTypes(res.BusinessTypes);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, businessTypes, fetchBusinessTypes };
}
